import React, { createContext, useState } from 'react';

export const context = createContext();

export const Provider = ({ children }) => {
  const [featureAccess, setFeatureAccess] = useState();
  const blockCampaignCreation = false;
  return <context.Provider value={{ featureAccess, setFeatureAccess, blockCampaignCreation }}>{children}</context.Provider>;
};
